import L from 'leaflet'

const defaultImgOptions = {
  rotate: 0,
  size: [20, 20],
  offset: { x: 0, y: 0 }
}

const PolylineDecorated = L.Polyline.extend({
  _updatePath() {
    if (!this.options || !this.options.decorator || !this.options.decorator.options) {
      L.Polyline.prototype._updatePath.call(this)
      return
    }

    const decoratorOptions = this.options.decorator.options
    if (!decoratorOptions.img || !decoratorOptions.img.url) {
      L.Polyline.prototype._updatePath.call(this)
      return
    }

    if (!decoratorOptions.img.el) {
      decoratorOptions.img = {
        ...defaultImgOptions,
        ...decoratorOptions.img
      }

      const img = document.createElement('img')
      img.src = decoratorOptions.img.url
      decoratorOptions.img.el = img
      img.onload = () => {
        this.redraw()
      }
      img.onerror = () => {
        decoratorOptions.img = null
      }
    } else {
      L.Polyline.prototype._updatePath.call(this)
      this._renderer._updateDecoratedPoly(this)
    }
  }
})

export function polylineDecorated(...options) {
  return new PolylineDecorated(...options)
}

export default PolylineDecorated



// WEBPACK FOOTER //
// ./src/helpers/leaflet-polyline-decorated.js